import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export default function AskNewaLauncher() {
  const navigate = useNavigate();
  const location = useLocation();
  const [hovered, setHovered] = useState(false);

  // Detect current module context from URL
  const getModule = () => {
    const path = location.pathname;
    if (path.startsWith('/crm')) return 'crm';
    if (path.startsWith('/finance')) return 'finance';
    if (path.startsWith('/inventory')) return 'inventory';
    if (path.startsWith('/hr')) return 'hr';
    if (path.startsWith('/reports')) return 'reports';
    return 'general';
  };

  const openWorkspace = () => {
    const mod = getModule();
    navigate(`/asknewa?module=${mod}`);
  };

  // Ctrl/Cmd + K global shortcut — hooks always called (not conditional)
  useEffect(() => {
    const handler = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault();
        openWorkspace();
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  });

  // Hide on the /asknewa page itself — AFTER all hooks
  if (location.pathname === '/asknewa') return null;

  return (
    <>
      <style>{`
        @keyframes nw-launch-pulse {
          0%, 100% { box-shadow: 0 6px 24px rgba(124,58,237,0.4), 0 0 0 0 rgba(124,58,237,0.25); }
          50% { box-shadow: 0 6px 24px rgba(124,58,237,0.4), 0 0 0 8px rgba(124,58,237,0.05); }
        }
        @keyframes nw-launch-in {
          from { opacity: 0; transform: scale(0.7) translateY(10px); }
          to   { opacity: 1; transform: scale(1) translateY(0); }
        }
        .nw-launcher-btn {
          animation: nw-launch-in 0.4s cubic-bezier(0.34,1.56,0.64,1), nw-launch-pulse 3s ease 0.4s infinite;
        }
        .nw-launcher-btn:hover {
          transform: scale(1.08) !important;
          box-shadow: 0 10px 32px rgba(124,58,237,0.5) !important;
          animation: none !important;
        }
      `}</style>

      {/* Floating launcher */}
      <div style={{ position: 'fixed', bottom: '24px', right: '24px', zIndex: 9999, display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '10px' }}>

        {/* Tooltip */}
        {hovered && (
          <div style={{
            background: '#1e1637', color: '#fff', borderRadius: '10px',
            padding: '8px 14px', fontSize: '12px', fontWeight: 600,
            whiteSpace: 'nowrap', boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
            animation: 'nw-launch-in 0.2s ease',
            lineHeight: 1.5,
          }}>
            <div>✦ Ask NEWA</div>
            <div style={{ fontSize: '10px', color: 'rgba(255,255,255,0.5)', fontWeight: 400, marginTop: '2px' }}>
              Ctrl + K to open
            </div>
            {/* Arrow */}
            <div style={{ position: 'absolute', bottom: '-6px', right: '22px', width: '12px', height: '12px', background: '#1e1637', transform: 'rotate(45deg)', borderRadius: '2px' }} />
          </div>
        )}

        <button
          className="nw-launcher-btn"
          onClick={openWorkspace}
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
          style={{
            width: '54px', height: '54px',
            borderRadius: '16px',
            background: 'linear-gradient(135deg, #7C3AED 0%, #5B21B6 50%, #22c7a8 100%)',
            border: 'none',
            cursor: 'pointer',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: '24px',
            color: '#fff',
            transition: 'transform 0.2s ease, box-shadow 0.2s ease',
          }}
          title="Open AskNEWA (Ctrl+K)"
        >
          ✦
        </button>
      </div>
    </>
  );
}
